module.exports = __webpack_public_path__ + "img/class6.8e50dbcd.png";